import elementExists from '../../core/utils/element-exists'
export default function CopyToClipBoard( selector = '[copy-to-clipboard]'){
    elements = document.querySelectorAll(selector);
    if( elementExists(elements, true )){
        elements.forEach(element => {
            const target = element.dataset.target;
            const targetElement = document.querySelector(target);
            if( elementExists(targetElement )){
                element.addEventListener('click', function(){
                    const text = targetElement.innerText;
                    navigator.clipboard.writeText( text ).then(function() {
                        alert( 'Copied ' + text + ' to your clipboard' )
                    });
                });
            }
        });
    }
}